var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrandNavigationSegment = void 0;

var react_1 = __importDefault(require("react"));

var core_1 = require("@wheelroom/core");

exports.BrandNavigationSegment = function (props) {
  var hasSegment = props.navigationSegment.length > 0;
  var hasBrandAction = hasSegment && Array.isArray(props.navigationSegment[0].actions) && props.navigationSegment[0].actions.length > 0;
  var brandAction = null;

  if (hasBrandAction) {
    brandAction = props.navigationSegment[0].actions[0];
  }

  var brandHeading = '';

  if (brandAction) {
    brandHeading = brandAction.heading;
  }

  var display = props.logoElement || brandHeading || props.siteHeading;

  if (hasBrandAction) {
    return react_1.default.createElement(core_1.Box, {
      is: "div",
      wheel: Object.assign(Object.assign({}, props.wheel), {
        style: props.wheel.style
      })
    }, react_1.default.createElement(core_1.Action, Object.assign({}, brandAction, {
      wheel: Object.assign(Object.assign({}, props.wheel), {
        style: props.wheel.style.action
      })
    }), display));
  } else return react_1.default.createElement(core_1.Box, {
    is: "div",
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style
    })
  }, react_1.default.createElement(core_1.Any, {
    is: "span",
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.branding
    })
  }, display));
};